<template>
  <div class="spread-scale">
    <div class="spread-scale__scale">
      <div class="spread-scale__scale-limit"><span class="spread-scale__scale-limit__label">100</span><div class="spread-scale__scale-limit__line"></div></div>
      <div class="spread-scale__scale-limit"><span class="spread-scale__scale-limit__label"></span><div class="spread-scale__scale-limit__line"></div></div>
      <div class="spread-scale__scale-limit"><span class="spread-scale__scale-limit__label">80</span><div class="spread-scale__scale-limit__line"></div></div>
      <div class="spread-scale__scale-limit"><span class="spread-scale__scale-limit__label"></span><div class="spread-scale__scale-limit__line"></div></div>
      <div class="spread-scale__scale-limit"><span class="spread-scale__scale-limit__label">60</span><div class="spread-scale__scale-limit__line"></div></div>
      <div class="spread-scale__scale-limit"><span class="spread-scale__scale-limit__label"></span><div class="spread-scale__scale-limit__line"></div></div>
      <div class="spread-scale__scale-limit"><span class="spread-scale__scale-limit__label">40</span><div class="spread-scale__scale-limit__line"></div></div>
      <div class="spread-scale__scale-limit"><span class="spread-scale__scale-limit__label"></span><div class="spread-scale__scale-limit__line"></div></div>
      <div class="spread-scale__scale-limit"><span class="spread-scale__scale-limit__label">20</span><div class="spread-scale__scale-limit__line"></div></div>
      <div class="spread-scale__scale-limit"><span class="spread-scale__scale-limit__label"></span><div class="spread-scale__scale-limit__line"></div></div>
      <div class="spread-scale__scale-limit"><span class="spread-scale__scale-limit__label">0</span><div class="spread-scale__scale-limit__line"></div></div>
      <div class="spread-scale__scale-limit"><span class="spread-scale__scale-limit__label"></span><div class="spread-scale__scale-limit__line"></div></div>
      <div class="spread-scale__scale-limit"><span class="spread-scale__scale-limit__label">20</span><div class="spread-scale__scale-limit__line"></div></div>
      <div class="spread-scale__scale-limit"><span class="spread-scale__scale-limit__label"></span><div class="spread-scale__scale-limit__line"></div></div>
      <div class="spread-scale__scale-limit"><span class="spread-scale__scale-limit__label">40</span><div class="spread-scale__scale-limit__line"></div></div>
      <div class="spread-scale__scale-limit"><span class="spread-scale__scale-limit__label"></span><div class="spread-scale__scale-limit__line"></div></div>
      <div class="spread-scale__scale-limit"><span class="spread-scale__scale-limit__label">60</span><div class="spread-scale__scale-limit__line"></div></div>
      <div class="spread-scale__scale-limit"><span class="spread-scale__scale-limit__label"></span><div class="spread-scale__scale-limit__line"></div></div>
      <div class="spread-scale__scale-limit"><span class="spread-scale__scale-limit__label">80</span><div class="spread-scale__scale-limit__line"></div></div>
      <div class="spread-scale__scale-limit"><span class="spread-scale__scale-limit__label"></span><div class="spread-scale__scale-limit__line"></div></div>
      <div class="spread-scale__scale-limit"><span class="spread-scale__scale-limit__label">100</span><div class="spread-scale__scale-limit__line"></div></div>
      <div class="spread-scale__scale-horizontal-line">
        <div class="spread-scale__scale-horizontal-line--percent-left">%</div>
        <div class="spread-scale__scale-horizontal-line--percent-right">%</div>
      </div>
      <div class="spread-scale__scale-vertical-line"></div>
    </div>
    <div class="spread-scale__value-row row-1">
      <div class="spread-scale__value-row__left">
        <div class="spread-scale__value-row__title">
          <template v-if="multiColor"><i18n-t keypath="pdfReport.preserving_heading" :locale="lang" tag="strong"></i18n-t></template>
          <template v-else><i18n-t keypath="pdfReport.decisiveness_low" :locale="lang" tag="strong"></i18n-t></template>
        </div>
        <template v-if="multiColor"><i18n-t keypath="pdfReport.preserving_subheading" :locale="lang" tag="div" class="spread-scale__value-row__subtitle"></i18n-t></template>
        <template v-else><i18n-t keypath="pdfReport.decisiveness_low_subheading" :locale="lang" tag="div" class="spread-scale__value-row__subtitle"></i18n-t></template>
        <div class="spread-scale__value-row__bar" :class="multiColor ? 'multicolor' : ''">
          <div v-if="determineBarCount(multiColor ? 'Preserving' : 'Decisiveness-low') > 0" class="spread-scale__value-row__bar--fill" :style="`width: ${(determineBarCount(multiColor ? 'Preserving' : 'Decisiveness-low') / totalCount) * 100}%;`">
            <span>{{ determineBarCount(multiColor ? 'Preserving' : 'Decisiveness-low') }}</span>
          </div>
        </div>
      </div>
      <div class="spread-scale__value-row__right">
        <div class="spread-scale__value-row__title">
          <template v-if="multiColor"><i18n-t keypath="pdfReport.changing_heading" :locale="lang" tag="strong"></i18n-t></template>
          <template v-else><i18n-t keypath="pdfReport.decisiveness_high" :locale="lang" tag="strong"></i18n-t></template>
        </div>
        <template v-if="multiColor"><i18n-t keypath="pdfReport.changing_subheading" :locale="lang" tag="div" class="spread-scale__value-row__subtitle"></i18n-t></template>
        <template v-else><i18n-t keypath="pdfReport.decisiveness_high_subheading" :locale="lang" tag="div" class="spread-scale__value-row__subtitle"></i18n-t></template>
        <div class="spread-scale__value-row__bar" :class="multiColor ? 'multicolor' : ''">
          <div v-if="determineBarCount(multiColor ? 'Changing' : 'Decisiveness-high') > 0" class="spread-scale__value-row__bar--fill" :style="`width: ${(determineBarCount(multiColor ? 'Changing' : 'Decisiveness-high') / totalCount) * 100}%;`">
            <span>{{ determineBarCount(multiColor ? 'Changing' : 'Decisiveness-high') }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="spread-scale__value-row row-2">
      <div class="spread-scale__value-row__left">
        <div class="spread-scale__value-row__title">
          <template v-if="multiColor"><i18n-t keypath="pdfReport.independent_heading" :locale="lang" tag="strong"></i18n-t></template>
          <template v-else><i18n-t keypath="pdfReport.socialimpact_low" :locale="lang" tag="strong"></i18n-t></template>
        </div>
        <template v-if="multiColor"><i18n-t keypath="pdfReport.independent_subheading" :locale="lang" tag="div" class="spread-scale__value-row__subtitle"></i18n-t></template>
        <template v-else><i18n-t keypath="pdfReport.socialimpact_low_subheading" :locale="lang" tag="div" class="spread-scale__value-row__subtitle"></i18n-t></template>
        <div class="spread-scale__value-row__bar" :class="multiColor ? 'multicolor' : ''">
          <div v-if="determineBarCount(multiColor ? 'Independent' : 'Social-impact-low') > 0" class="spread-scale__value-row__bar--fill" :style="`width: ${(determineBarCount(multiColor ? 'Independent' : 'Social-impact-low') / totalCount) * 100}%;`">
            <span>{{ determineBarCount(multiColor ? 'Independent' : 'Social-impact-low') }}</span>
          </div>
        </div>
      </div>
      <div class="spread-scale__value-row__right">
        <div class="spread-scale__value-row__title">
          <template v-if="multiColor"><i18n-t keypath="pdfReport.relationoriented_heading" :locale="lang" tag="strong"></i18n-t></template>
          <template v-else><i18n-t keypath="pdfReport.socialimpact_high" :locale="lang" tag="strong"></i18n-t></template>
        </div>
        <template v-if="multiColor"><i18n-t keypath="pdfReport.relationoriented_subheading" :locale="lang" tag="div" class="spread-scale__value-row__subtitle"></i18n-t></template>
        <template v-else><i18n-t keypath="pdfReport.socialimpact_high_subheading" :locale="lang" tag="div" class="spread-scale__value-row__subtitle"></i18n-t></template>
        <div class="spread-scale__value-row__bar" :class="multiColor ? 'multicolor' : ''">
          <div v-if="determineBarCount(multiColor ? 'Relation-oriented' : 'Social-impact-high') > 0" class="spread-scale__value-row__bar--fill" :style="`width: ${(determineBarCount(multiColor ? 'Relation-oriented' : 'Social-impact-high') / totalCount) * 100}%;`">
            <span>{{ determineBarCount(multiColor ? 'Relation-oriented' : 'Social-impact-high') }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="spread-scale__value-row row-3">
      <div class="spread-scale__value-row__left">
        <div class="spread-scale__value-row__title">
          <template v-if="multiColor"><i18n-t keypath="pdfReport.flexible_heading" :locale="lang" tag="strong"></i18n-t></template>
          <template v-else><i18n-t keypath="pdfReport.stressmanagement_low" :locale="lang" tag="strong"></i18n-t></template>
        </div>
        <template v-if="multiColor"><i18n-t keypath="pdfReport.flexible_subheading" :locale="lang" tag="div" class="spread-scale__value-row__subtitle"></i18n-t></template>
        <template v-else><i18n-t keypath="pdfReport.stressmanagement_low_subheading" :locale="lang" tag="div" class="spread-scale__value-row__subtitle"></i18n-t></template>
        <div class="spread-scale__value-row__bar" :class="multiColor ? 'multicolor' : ''">
          <div v-if="determineBarCount(multiColor ? 'Flexible' : 'Stress-management-low') > 0" class="spread-scale__value-row__bar--fill" :style="`width: ${(determineBarCount(multiColor ? 'Flexible' : 'Stress-management-low') / totalCount) * 100}%;`">
            <span>{{ determineBarCount(multiColor ? 'Flexible' : 'Stress-management-low') }}</span>
          </div>
        </div>
      </div>
      <div class="spread-scale__value-row__right">
        <div class="spread-scale__value-row__title">
          <template v-if="multiColor"><i18n-t keypath="pdfReport.structured_heading" :locale="lang" tag="strong"></i18n-t></template>
          <template v-else><i18n-t keypath="pdfReport.stressmanagement_high" :locale="lang" tag="strong"></i18n-t></template>
        </div>
        <template v-if="multiColor"><i18n-t keypath="pdfReport.structured_subheading" :locale="lang" tag="div" class="spread-scale__value-row__subtitle"></i18n-t></template>
        <template v-else><i18n-t keypath="pdfReport.stressmanagement_high_subheading" :locale="lang" tag="div" class="spread-scale__value-row__subtitle"></i18n-t></template>
        <div class="spread-scale__value-row__bar" :class="multiColor ? 'multicolor' : ''">
          <div v-if="determineBarCount(multiColor ? 'Structured' : 'Stress-management-high') > 0" class="spread-scale__value-row__bar--fill" :style="`width: ${(determineBarCount(multiColor ? 'Structured' : 'Stress-management-high') / totalCount) * 100}%;`">
            <span>{{ determineBarCount(multiColor ? 'Structured' : 'Stress-management-high') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    lang: '',
    totalCount: 0,
    isSpread: false,
    multiColor: false,
    data: {}
  },
  methods: {
    determineBarCount(attribute) {
      if (this.isSpread) {
        return this.data.filter(i => !!i.spread.find(item => item.attribute === attribute)).length
      }
      return this.data.filter(i => !!i.characteristic.find(item => item.attribute === attribute)).length
    }
  }
}
</script>

<style scoped lang="scss">
.spread-scale {
  $spreadscale: &;
  position: relative;
  overflow: hidden;
  width: 460px;

  &__scale {
    position: relative;
    width: 460px;
    margin: 18px 0 0 0;

    &-limit {
      position: relative;
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 8pt;
      width: calc(460px / 21);

      &:first-child,
      &:nth-child(11),
      &:nth-child(21) {
        #{$spreadscale}__scale-limit__label {
          font-weight: 900;
        }
      }

      &:nth-child(11) {
        #{$spreadscale}__scale-limit__line {
          width: 1px;
        }
      }

      &__label {
        position: absolute;
        top: -10px;
        left: 2px;
        width: calc(100% - 4px);
        text-align: center;
        font-size: 7px;
      }

      &__line {
        width: 0.5pt;
        height: 8pt;
        background-color: #000000;
      }
    }

    &-horizontal-line {
      position: absolute;
      left: calc((460px / 21) / 2);
      top: 8px;
      width: calc(460px - (460px / 21));
      height: 0.5pt;
      background-color: #000000;

      &--percent-left {
        position: absolute;
        width: 10px;
        height: 7px;
        left: -10px;
        top: -6px;
        font-size: 8px;
      }
      &--percent-right {
        position: absolute;
        width: 10px;
        height: 7px;
        right: -13px;
        top: -6px;
        font-size: 8px;
      }
    }

    &-vertical-line {
      position: absolute;
      left: calc((460px / 2) - 0.5px);
      top: 8px;
      height: 166px;
      background-color: #000000;
      width: 1px;
      z-index: 1;
    }
  }

  &__value-row {
    position: relative;
    width: calc(460px - (460px / 21));
    margin: 10px calc((460px / 21) / 2);

    &__left {
      position: relative;
      width: 50%;
      display: inline-block;
    }
    &__right {
      position: relative;
      width: 50%;
      display: inline-block;
      text-align: right;
    }
    &__title {
      font-size: 8px;
      & > strong {
        font-size: 8px;
      }
    }
    &__subtitle {
      font-size: 8px;
    }
    &__bar {
      margin-top: 1px;
      position: relative;
      height: 16px;
      width: 100%;
      background-color: #f4f4f4;

      &.multicolor {
        .row-1 & {
          background-color: #e6f0f8;
        }
        .row-2 & {
          background-color: #f1eff6;
        }
        .row-3 & {
          background-color: #edf6f7;
        }
      }

      &--fill {
        position: absolute;
        top: 0;
        height: 16px;
        padding: 0 6px;
        background-color: #8c8c8c;

        .multicolor & {
          .row-1 & {
            background-color: #0069b4;
          }
          .row-2 & {
            background-color: #7761a7;
          }
          .row-3 & {
            background-color: #4fa8b1;
          }
        }

        & > span {
          position: relative;
          display: block;
          color: #ffffff;
          line-height: 16px;
          height: 16px;
          font-size: 8px;
          font-weight: 900;
          z-index: 1;
        }

        #{$spreadscale}__value-row__left & {
          right: 0;
          border-top-left-radius: 8px;
          border-bottom-left-radius: 8px;
        }
        #{$spreadscale}__value-row__right & {
          left: 0;
          border-top-right-radius: 8px;
          border-bottom-right-radius: 8px;
          text-align: right;
        }
      }
    }
  }
}
</style>
